module.exports = __webpack_public_path__ + "img/calendar.f30fabda.svg";